import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-share',
  templateUrl: './icon-share.component.html',
  styleUrls: ['./icon-share.component.scss']
})
export class IconShareComponent implements OnInit {
  @Input() color = '#262628';
  @Input() size = 18;

  constructor() { }

  ngOnInit() {
  }

}
